<template>
  <div>
    <title-paid title="Facturas Fechadas"></title-paid>
    <paid-component></paid-component>
  </div>
</template>

<script>
import Title from "../geral/Title";
import PaidComponent from "./invoices/PaidComponent";
export default {
  components: { PaidComponent, "title-paid": Title },
  name: "PaidInvoice"
};
</script>

<style scoped></style>
